import { Directive } from '@angular/core'

/**
 * Amplitude (product analytics) is configured to hide all text, so things like names and speech-to-text never leave
 * the browser. This directive lets it record the text inside the element it's on. It's not strictly needed, as
 * clicks are queryable by selector either way, but it makes event names readable and session replays easier to
 * follow.
 *
 * Add it to a component's `hostDirectives` when the whole component is safe to show, or put it on just the safe
 * part of a template. To hide data inside an unmasked element, use `ftrAmplitudeMask`.
 *
 * @example
 * ```ts
 * hostDirectives: [AmplitudeUnmaskDirective]
 * ```
 *
 * @example
 * ```html
 * <h2 ftrAmplitudeUnmask>Account details</h2>
 * <p>{{ user.email }}</p>
 * ```
 */
@Directive({
  standalone: true,
  selector: '[ftrAmplitudeUnmask]',
  host: { 'data-amp-unmask': '' },
})
export class AmplitudeUnmaskDirective {}
